import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import GeneralAlert from "../../components/common/GeneralAlert";
import { Team } from "../../types/team";
import useTeamLogic from "../../hooks/logic/teamLogic";

interface TeamPageWrapperProps {
  Component: React.FC<{
    systemLanguageType: Team["system_language_type"];
  }>;
}

const TeamPageWrapper: React.FC<TeamPageWrapperProps> = ({ Component }) => {
  const navigate = useNavigate();
  const { system_language_type } = useParams<{
    system_language_type?: string;
  }>();
  const { systemLanguageType } = useTeamLogic(system_language_type);

  if (!systemLanguageType) {
    return (
      <GeneralAlert
        errorMessage="Invalid system language type"
        action={() => navigate(-1)}
        actionLabel="Go Back"
      />
    );
  }

  return <Component systemLanguageType={systemLanguageType} />;
};

export default TeamPageWrapper;
